import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { AppConsts } from '../../../shared/AppConsts';
import { GetConfigureGraphStatesDto, GraphStateDto } from '../../../shared/service-proxies/service-proxies';
var DefaultSimulateRemoteGraphProtocol = /** @class */ (function () {
    function DefaultSimulateRemoteGraphProtocol(graphService, configureGalleryService) {
        this.graphService = graphService;
        this.configureGalleryService = configureGalleryService;
        this.version = 1;
        this.remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;
    }
    DefaultSimulateRemoteGraphProtocol.prototype.getSystemGraphConfig = function (graphId) {
        return this.graphService.getGraphConfig(graphId);
    };
    DefaultSimulateRemoteGraphProtocol.prototype.getAbsoluteStateUrl = function (graphId, stateUrl) {
        return this.graphService.getAbsoluteStateUrl(graphId, stateUrl);
    };
    DefaultSimulateRemoteGraphProtocol.prototype.getReleasedGraphStates = function (input) {
        var dto = new GetConfigureGraphStatesDto();
        dto.states = _.map(input.states, function (state) { return new GraphStateDto(state); });
        return this.configureGalleryService.pullConfigureGraphStates(dto).pipe(map(function (result) {
            return _.map(result.items, function (item) {
                if (item.result) {
                    return {
                        graphId: item.graphId, stateIndex: item.stateIndex,
                        result: { url: item.result.url, type: item.result.type }
                    };
                }
                else {
                    return { graphId: item.graphId, stateIndex: item.stateIndex };
                }
            });
        }));
    };
    DefaultSimulateRemoteGraphProtocol.prototype.getGraphStateUrl = function (graphId, stateIndex, fill, stroke) {
        var query = "/Gallary/GetConfigureGraphState?";
        var segment = "graphId=" + graphId + "&stateIndex=" + stateIndex + "&fill=" + fill + "&stroke=" + stroke;
        return "" + this.remoteServiceBaseUrl + query + "&" + segment;
    };
    return DefaultSimulateRemoteGraphProtocol;
}());
export { DefaultSimulateRemoteGraphProtocol };
